import axios from "axios";
import React, { useEffect, useState } from "react";
import "../add-staff/adduser.scss";
import { useNavigate, useParams } from "react-router-dom";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import Loading from "../../components/loading/Loading";

function Editspa() {
  const [loading, setLoading] = useState();
  const { id } = useParams();
  const [name, setName] = useState();
  const [pdf, setPdf] = useState();
  const [image, setImage] = useState();
  const [modalShow, setModalShow] = useState(false);
  const navigate = useNavigate();
  const [title, setTitle] = useState();
  const sizeImage = 1000000;
  const sizePdf = 5000000;

  const getData = async () => {
    const result = await axios.get(`https://mobile.amospa.com/spa/${id}`);
    handlesetAdd(result.data.data[0]);
    setName(result.data.data[0].name);
    setPdf(result.data.data[0].pdf);
    setImage(result.data.data[0].image);
  };

  const [add, setAdd] = useState({
    name: "",
    pdf: "",
    image: "",
  });

  const handlesetAdd = (data) => {
    setAdd({
      name: data.name,
      pdf: data.pdf,
      image: data.image,
    });
  };

  const updateCafe = async () => {
    const update = new FormData();
    if (image?.size > sizeImage || pdf?.size > sizePdf) {
      setTitle("File size is too Big, Maximum size 1MB");
      setModalShow(true);
    }else if (name !== add.name || pdf !== add.pdf || image !== add.image) {
      update.append("name", name);
      update.append("pdf", pdf);
      update.append("picture", image);
      setLoading(true);
      await axios.put(`https://mobile.amospa.com/spa/${id}`, update);
      setLoading(false);
      setTitle("Success Update Spa");
      setModalShow(true);
    } else {
      setTitle("No Data Change");
      setModalShow(true);
    }
  };

  //Handle Next
  const handleNext = async () => {
    setModalShow(false);
    navigate("/homepage/spa");
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div className="container-fluid">
      {loading ? (
        <Loading />
      ) : (
        <div className="row">
          <div className="col-12">
            <div className="wrapper-add-user">
              <div className="wrapper-edit-image">
                <div className="header-edit-image">
                  <h5 className="m-0">Add Spa</h5>
                </div>
                <div className="data-user">
                  <div className="wrapper-data">
                    <label>Name</label>
                    <input
                      type="text"
                      name="name"
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>
                      PDF (Max 5MB)<span className="text-danger">*</span>{" "}
                      <span className="text-danger ms-2">
                        {pdf && pdf.size > sizePdf
                          ? "File size is too Big"
                          : ""}
                      </span>
                    </label>
                    <input
                      style={{ height: "100%" }}
                      type="file"
                      name="pdf"
                      onChange={(e) => setPdf(e.target.files[0])}
                    />
                  </div>
                  <div className="wrapper-data">
                    <label> Picture (Max 1MB)<span className="text-danger">*</span>{" "}
                      <span className="text-danger ms-2">
                        {image && image.size > sizeImage
                          ? "Image size is too Big"
                          : ""}
                      </span></label>
                    <input
                      style={{ height: "100%" }}
                      type="file"
                      name="picture"
                      onChange={(e) => setImage(e.target.files[0])}
                    />
                  </div>
                  <button onClick={() => updateCafe()}>Update</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={title}
        nextButton={handleNext}
      />
    </div>
  );
}

export default Editspa;
